export default {
      id: "i-file-pdf-usage",
      viewBox: "0 0 128 128",
      url: __webpack_public_path__ + "img/sprite.svg#i-file-pdf",
      toString: function () {
        return this.url;
      }
    }